import Dialog from "client/components/layout/Dialog";
import Spacer from "client/components/layout/Spacer";
import DropdownProperty from "client/components/properties/DropdownProperty";
import { projectStatesRenderData } from "client/interfaces/ProjectStates";
import { useState } from "react";
import { IAppScenario } from "src/classes/api/GQL/scenarios/gql";
import ScenarioUtils from "src/classes/utilities/ScenarioUtils";

interface ILoadScenarioModalProps
{
	scenario: IAppScenario;
	revisions?: IAppScenario[];
	index?: number;
	onShutdown?: () => void;
}

const LoadScenarioModal = (props: ILoadScenarioModalProps) => 
{
	const isRevision = props.revisions?.length && props.index !== undefined;

	const [currentScenario, setCurrentScenario] = useState<IAppScenario>(isRevision ? props.revisions![props.index!] : props.scenario);
	
	const scenarioStateRenderData = currentScenario?.state ? projectStatesRenderData.get(currentScenario?.state) : undefined;
	
	return (
		<Dialog className={"loadScenarioModal"}
			data-name={"load-scenario-modal"}
			title={props.scenario.revisionGroupName}
			showCloseButton={false}
			onShutdown={props.onShutdown}
			actions={[
				{
					label: "Load",
					onClick: async () => 
					{
						ScenarioUtils.loadScenario(props.scenario);
						props.onShutdown?.();
					}
				},
				{
					label: "Cancel",
					onClick: props.onShutdown,
				}
			]}
		>
			{
				isRevision &&
					<div className={"revisionSelector"}>
						<DropdownProperty data-name={"revision-selector"}
							className={"fit"}
							noWidthConstraint
							value={currentScenario.id}
							options={props.revisions!.map((revision) => ({ value: revision.id, display: revision.revisionName })) || []}
							onCommitCallback={(id) => setCurrentScenario(props.revisions!.find((revision) => revision.id === id)!)}
						/>
						<Spacer stretchTo={{ x: "100%" }} />
						<div data-name={"revision-state"}
							className={""}
							style={{ color: scenarioStateRenderData?.color }}
						>
							{ scenarioStateRenderData?.label }
						</div>
						{/* <InfoIconRound data-name={"revision-history-prompt"}
							onClick={() => 
							{
								// TODO: show revision history
							}}
						/> */}
					</div>
			}
			<Spacer size={{ y: "10px" }} />
			{
				currentScenario.description !== "WL Create 2.0 Scenario" ? currentScenario.description : null
			}
		</Dialog>
	);
};

export default LoadScenarioModal;